class BlogFilters extends HTMLElement {
  constructor() {
    super();

    this.handleOnScroll = this.handleOnScroll.bind(this);
  }

  connectedCallback() {
    this.blogContainer = document.querySelector('[data-blog-container]');

    this.attachEvents();
  }

  attachEvents() {
    window.addEventListener('scroll', this.handleOnScroll);
  }

  handleOnScroll() {
    if (!this.blogContainer) return;

    const rect = this.blogContainer.getBoundingClientRect();
    const scrollBottomPosition = window.scrollY + window.innerHeight;
    const topPositionblogContainer = window.scrollY + rect.top;
    const bottomPositionblogContainer =
      window.scrollY + rect.top + this.blogContainer.offsetHeight;
    const isVisible =
      scrollBottomPosition > topPositionblogContainer &&
      scrollBottomPosition < bottomPositionblogContainer;

    this.classList.toggle('is-visible', isVisible);
  }
}

customElements.define('blog-filters', BlogFilters);
